<template>
  <div class="student-list">
    <el-table ref="multipleTable" :data="studentData" tooltip-effect="dark" style="width: 100%"
      @selection-change="handleSelectionChange" class="common-edit-button" empty-text="暂无数据"
      height="calc(100vh - 280px)">
      <el-table-column fixed type="selection" width="55"></el-table-column>
      <!-- <el-table-column label="#" type="index"> </el-table-column> -->
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="班级职务" style="width: 30%;">
              <span>{{ props.row.duty }}</span>
            </el-form-item>
            <el-form-item label="政治面貌" style="width: 30%;">
              <span>{{ props.row.politicsStatus }}</span>
            </el-form-item>
            <el-form-item label="民族" style="width: 30%;">
              <span>{{ props.row.nation }}</span>
            </el-form-item>
            <el-form-item label="籍贯" style="width: 30%;">
              <span>{{ props.row.nativePlace }}</span>
            </el-form-item>
            <el-form-item label="出生年月" style="width: 30%;">
              <span>{{ props.row.birthday }}</span>
            </el-form-item>
            <el-form-item label="过敏源" style="width: 30%;">
              <span>{{ props.row.allergen }}</span>
            </el-form-item>
            <el-form-item label="毕业小学" style="width: 30%;">
              <span>{{ props.row.primarySchool }}</span>
            </el-form-item>
            <el-form-item label="学生电话" style="width: 30%;">
              <span>{{ props.row.studentPhone }}</span>
            </el-form-item>
            <el-form-item label="家长电话" style="width: 30%;">
              <span>{{ props.row.patriarchPhone }}</span>
            </el-form-item>
            <el-form-item label="家庭地址" style="width: 30%;">
              <span>{{ props.row.address }}</span>
            </el-form-item>
            <el-form-item label="病史" style="width: 30%;">
              <span>{{ props.row.medicalHistory }}</span>
            </el-form-item>
            <el-form-item label="身份证" style="width: 30%;">
              <span>{{ props.row.idCard }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="studentNumber" label="学号" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="studentName" label="姓名" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="sex" label="性别" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="gradeName" label="年级" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="className" label="班级" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="status" label="学生状态" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{
            studentTypeList.find(item => item.dictValue == scope.row.status)?.dictLabel || '未知状态'
          }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="gradeClass"
        label="年级班级"
        width="150px"
        :show-overflow-tooltip="true"
      >
      </el-table-column> -->
      <!-- <el-table-column prop="duty" label="班级职务" width="100px" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="politicsStatus" label="政治面貌" width="100px" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="nation" label="民族" width="100px" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="nativePlace" label="籍贯" width="100px" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="birthday" label="出生年月" width="100px" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="allergen" label="过敏源" width="100px" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="primarySchool" label="毕业小学" width="100px" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="学生电话" width="150px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div class="copy-wrapper">
              <span class="text">{{ scope.row.studentPhone }}</span>
              <el-button size="mini" icon="el-icon-copy-document"
                @click="copyAddress(scope.row.studentPhone, '学生电话', scope.row)" circle></el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="家长电话" width="150px">
          <template slot-scope="scope">
            <div class="copy-wrapper">
              <span class="text">{{ scope.row.patriarchPhone }}</span>
              <el-button size="mini" icon="el-icon-copy-document"
                @click="copyAddress(scope.row.patriarchPhone, '家长电话', scope.row)" circle></el-button>
            </div>
          </template>
        </el-table-column> -->
      <!-- <el-table-column label="家庭地址" width="150px">
          <template slot-scope="scope">
            <div class="copy-wrapper">
              <span class="text">{{ scope.row.address }}</span>
              <el-button size="mini" icon="el-icon-copy-document"
                @click="copyAddress(scope.row.address, '家庭地址', scope.row)" circle></el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="病史" width="150px">
          <template slot-scope="scope">
            <div class="copy-wrapper">
              <span class="text">{{ scope.row.medicalHistory }}</span>
              <el-button size="mini" icon="el-icon-copy-document"
                @click="copyAddress(scope.row.medicalHistory, '病史', scope.row)" circle></el-button>
            </div>
          </template>
        </el-table-column> -->
      <el-table-column label="操作" width="550" fixed="right">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 重大经历 -->
            <!-- <el-button type="success" icon="el-icon-info" size="small" @click="lifeExperienceClick(scope.row)">
              重大经历
            </el-button> -->
            <!-- 学生行为-奖惩记录 -->
            <el-button type="success" icon="el-icon-info" size="small" v-hasPermi="'sc:studentrecord_stu:query'"
              @click="studentExperienceClick(scope.row)">
              学生行为
            </el-button>
            <!-- 家庭成员 -->
            <el-button type="success" icon="el-icon-user-solid" size="small" @click="familyClick(scope.row)">
              家庭成员
            </el-button>
            <!-- 素质报告书 -->
            <el-button type="success" icon="el-icon-notebook-2" @click="reportClick(scope.row)"
              v-hasPermi="'sc:semesterdata:query'" size="small">
              报告书
            </el-button>
            <!-- 修改 -->
            <el-button type="warning" icon="el-icon-edit" @click="editClick(scope.row)" v-hasPermi="'sc:student:edit'"
              size="small">修改
            </el-button>
            <!-- 删除 -->
            <el-button type="danger" icon="el-icon-delete" @click="deleteClick(scope.row)"
              v-hasPermi="'sc:student:delete'" size="small">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改学生信息 -->
    <studentInfoEditStudent :dialogFormVisible.sync="editShow" :gradeSelectList="gradeSelectList"
      :classSelectList="classSelectList" :studentInfo="studentInfo" :classProps="classProps" :classSelect="classSelect"
      :classPlaceholder="classPlaceholder" :classInfoArr="classInfoArr" :studentTypeList="studentTypeList"
      v-show="editShow" />
    <!-- 素质报告书 -->
    <qualityReportDialog :dialogFormVisible.sync="qualityReportShow" :studentSemesterData="studentSemesterData"
      :titleColspan="titleColspan" :contentColspan="contentColspan" :jobColspan="jobColspan" :rateColspan="rateColspan"
      :rateOptions="rateOptions" :semesterOptions="semesterOptions" :schoolInfo="schoolInfo" :jobData="jobData"
      :classProps="classProps" :classSelect="classSelect" :classPlaceholder="classPlaceholder" :classData="classData"
      :selectStudent="selectStudent" @inquireClick="inquireClick" @dialogClose="dialogClose" v-if="qualityReportShow" />
    <!-- 家庭成员 -->
    <familyDialog v-if="familyDialogShow" :studentInfo="studentInfo" :familyData="familyData"
      :familyDialogShow.sync="familyDialogShow" @updateFamilyData="getFamilyData" />
    <!-- 重大经历 -->
    <lifeExperienceDialog v-if="lifeExperienceDialogShow" :studentInfo="studentInfo"
      :importantEventOptions="importantEventOptions" :semesterOptions="semesterOptions"
      :lifeExperienceDialogShow.sync="lifeExperienceDialogShow" />
    <!-- 学生行为 -->
    <studentExperienceDialog v-if="studentExperienceDialogShow"
      :studentExperienceDialogShow.sync="studentExperienceDialogShow" :semesterOptions="semesterOptions"
      :studentInfo="studentInfo" :classTeacherList="classTeacherList" :studentSupervisorList="studentSupervisorList" />
  </div>
</template>

<script>
import studentInfoEditStudent from "../studentifno-editstudent/studentifno-editstudent.vue";
import qualityReportDialog from "../quality-report-dialog/quality-report-dialog.vue";
import familyDialog from "../family-dialog/familyDialog.vue";
import lifeExperienceDialog from "../life-experience-dialog/lifeExperienceDialog.vue";
import studentExperienceDialog from "../student-experience-dialog/studentExperience.vue";
export default {
  components: {
    studentInfoEditStudent,
    qualityReportDialog,
    familyDialog,
    lifeExperienceDialog,
    studentExperienceDialog
  },
  data() {
    return {
      title: "修改学生信息",
      studentInfo: {},
      editShow: false,
      qualityReportShow: false,
      classInfoArr: [],
      classPlaceholder: "",
      studentSemesterData: {},
      titleColspan: 8, // 标题
      contentColspan: 3, // 内容
      jobColspan: 4, // 职务
      rateColspan: 6, // 班主任评级
      rateOptions: [],
      schoolInfo: {},
      jobData: {}, // 职务和政治面貌-报告书用
      semesterOptions: [],
      schoolYear: "",
      semester: "",
      selectStudent: {},
      selectClassData: null,
      familyDialogShow: false,
      familyData: [], // 家庭成员数据
      lifeExperienceDialogShow: false,
      studentExperienceDialogShow: false, // 学生行为弹窗
      classTeacherList: [], // 班主任列表
      studentSupervisorList: [], // 学生导师列表
    };
  },
  inject: ["standard", "refresh"],
  props: [
    "studentData",
    "classProps",
    "classSelect",
    "studentTypeList",
    "classData",
    "gradeSelectList",
    "classSelectList"
  ],
  created() {
    this.getEvaluationGrade();
    this.getSemesterType();
    this.getSchoolDetails();
    this.getImportantEvent();
    this.getClassTeacherList();
  },
  mounted() {
    // 初始化赋值默认选中的班级数据
    setTimeout(() => {
      this.selectClassData = this.classData;
      // console.log("this.classData：", this.classData);
    }, 1000);
  },
  watch: {
    classData(newVal, oldVal) {
      this.selectClassData = newVal;
      // console.log("this.classData：", this.classData);
    },
  },
  methods: {
    // 重大事件字典
    getImportantEvent() {
      this.get(`${this.$url.getDictType}/sc_important_event`).then((res) => {
        this.importantEventOptions = res.data;
      });
    },
    // 重大经历
    lifeExperienceClick(row) {
      this.studentInfo = row;
      this.lifeExperienceDialogShow = true;
    },
    // 查询班主任列表
    getClassTeacherList() {
      this.get(this.$url.getClassTeacherList + '?schoolId=' + this.school.id + '&isCharge=1').then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.classTeacherList = res.data;
      })
    },
    // 学生行为
    studentExperienceClick(row) {
      this.studentInfo = row;
      // 查询学生导师
      this.get(this.$url.selectStudentSupervisor + "?studentId=" + row.id).then(res => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.studentSupervisorList = res.data;
        this.studentExperienceDialogShow = true;
      })
    },
    // 家庭成员
    familyClick(row) {
      this.studentInfo = row;
      this.getFamilyData();
      this.familyDialogShow = true;
    },
    getFamilyData() {
      this.get(this.$url.selectStudentFamilyList + "?studentId=" + this.studentInfo.id).then(res => {
        // console.log("家庭成员:", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.familyData = res.rows;
      })
    },
    // 关闭统计表弹窗时重新赋值初始化时的班级数据
    dialogClose(e) {
      this.selectClassData = this.classData;
      this.qualityReportShow = e;
      this.getSchoolDetails();
    },
    // 查询学校信息
    getSchoolDetails() {
      this.get(this.$url.getSchoolDetails).then((res) => {
        // console.log("查询学校信息==>", res);
        this.schoolInfo = res.data;
        this.semester = res.data.semester;
        this.schoolYear = res.data.schoolYear;
      });
    },
    // 获取考试评定类型选择列表数据
    getEvaluationGrade() {
      this.get(`${this.$url.getDictType}/evaluation_grade`).then((res) => {
        // console.log("评级：", res);
        this.rateOptions = res.data;
      });
    },
    // 获取学期类型选择列表数据
    getSemesterType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
      this.$emit("studentSelect", this.selectList);
    },
    async copyAddress(textToCopy, label) {
      if (!textToCopy) {
        this.$message.warning('内容为空！');
        return;
      }

      // 方案1：使用现代 Clipboard API（推荐）
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(textToCopy);
          this.$message.success(`已复制 ${label}`);
          return;
        } catch (err) {
          console.error('Clipboard API 复制失败:', err);
          // 可能是权限被拒绝，尝试降级
        }
      }

      // 方案2：降级使用 document.execCommand（兼容旧环境）
      this.fallbackCopyText(textToCopy, label);
    },
    fallbackCopyText(text, label) {
      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();

      try {
        const success = document.execCommand('copy');
        document.body.removeChild(input);
        if (success) {
          this.$message.success(`已复制 ${label}`);
        } else {
          this.$message.error('复制失败');
        }
      } catch (err) {
        document.body.removeChild(input);
        this.$message.error('当前浏览器不支持复制');
      }
    },
    // copyAddress(studentId) {
    //   let copyVal = document.getElementById(studentId);
    //   copyVal.select();
    //   try {
    //     document.execCommand("copy");
    //     if (copyVal.value == "") {
    //       this.$message.warning("内容为空！");
    //     } else {
    //       this.$message.success("已复制到粘贴板");
    //     }
    //   } catch {
    //     this.$message.error("当前浏览器不支持复制到粘贴板");
    //   }
    // },
    inquireClick(e) {
      this.semester = e.semesterVal;
      this.schoolYear =
        typeof e.schoolYearVal == "string"
          ? e.schoolYearVal
          : "" + e.schoolYearVal.getFullYear();
      // 将班级数据设置为选中的班级
      this.selectClassData = e.classNameVal;
      this.reportClick(this.selectStudent);
    },
    reportClick(item) {
      // console.log("item:", item);
      this.classPlaceholder = `${item.gradeName} / ${item.className}`;
      this.selectStudent = item;
      let data = {
        schoolId: this.user.schoolId,
        gradeId: item.gradeId,
        classId: item.classId,
        studentId: item.id,
        schoolYear: this.schoolYear,
        semester: this.semester,
      };
      this.post(this.$url.selectStudentSemesterData, data).then((res) => {
        // console.log("获取学生数据统计==>", res);
        // 从 examInfo 中提取所有科目
        const allSubjects = res.data.examInfo.flatMap((exam) =>
          exam.scores.map((score) => ({
            courseId: score.courseId,
            courseName: score.courseName,
          }))
        );

        // 使用 Set 去重
        const uniqueSubjects = [
          ...new Set(allSubjects.map((subject) => subject.courseId)),
        ].map((courseId) =>
          allSubjects.find((subject) => subject.courseId === courseId)
        );
        // console.log(uniqueSubjects);

        res.data["uniqueSubjects"] = uniqueSubjects;

        // 设置table表格Colspan属性
        // if (uniqueSubjects.length > 2) {
        //   this.titleColspan = uniqueSubjects.length + 1;
        //   this.contentColspan = uniqueSubjects.length - 2;
        //   this.jobColspan = uniqueSubjects.length;
        //   this.rateColspan = uniqueSubjects.length - 1;
        // } else {
        //   this.disciplineColspan = this.titleColspan - uniqueSubjects.length;
        // }
        if (uniqueSubjects.length > 2) {
          this.titleColspan = 7 + 1;
          this.contentColspan = 7 - 2;
          this.jobColspan = 7;
          this.rateColspan = 7 - 1;
        } else {
          this.disciplineColspan = this.titleColspan - uniqueSubjects.length;
        }

        // 将moralismGrade设置为字符串，否则报告书会显示数字
        if (res.data.semesterEvaluate) {
          res.data.semesterEvaluate["moralismGrade"] =
            "" + res.data.semesterEvaluate.moralismGrade;
        }

        this.studentSemesterData = res.data;

        // 存储学生职务和政治面貌，以便报告书修改添加时使用
        // semesterEvaluate存在则使用semesterEvaluate的数据，否则使用studentInfo中的，两者数据可能存在不同
        const { semesterEvaluate } = res.data;
        this.jobData = {
          duty: semesterEvaluate ? semesterEvaluate.classJob : "",
          politicsStatus: semesterEvaluate
            ? semesterEvaluate.politicsStatus
            : "",
        };

        // 报告书显示
        this.qualityReportShow = true;

        console.log("this.studentSemesterData:", this.studentSemesterData);
      });
    },
    // 点击编辑
    editClick(item) {
      this.classInfoArr = [
        {
          gradeId: item.gradeId,
          gradeName: item.gradeName,
        },
        {
          classId: item.classId,
          className: item.className,
        },
      ];
      this.classPlaceholder = `${item.gradeName} / ${item.className}`;
      // console.log(item);
      this.studentInfo = item;
      this.editShow = true;
    },
    // 点击删除
    deleteClick(item) {
      // console.log(item);
      this.$confirm("是否删除该学生信息?", "删除学生", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除学生信息接口
          let list = [];
          list.push(item.id);
          this.post(this.$url.deleteStudentPC, list)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // console.log(err);
              // this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
  },
};
</script>

<style>
@import "./studentInfo-studentList.scss";
</style>
